/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Pricing_Feat4Inputs */

const en_st_pricing_feat4 = /** @type {(inputs: St_Pricing_Feat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handover package + cost per feature`)
};

const id_st_pricing_feat4 = /** @type {(inputs: St_Pricing_Feat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket serah terima + biaya per fitur`)
};

/**
* | output |
* | --- |
* | "Handover package + cost per feature" |
*
* @param {St_Pricing_Feat4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_pricing_feat4 = /** @type {((inputs?: St_Pricing_Feat4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Pricing_Feat4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_pricing_feat4(inputs)
	return en_st_pricing_feat4(inputs)
});